'use strict';

var RuleCustomStrategyListingTransformerFactory = function RuleCustomStrategyListingTransformerFactory(StrategyListingTransformer) {
  function RuleCustomStrategyListingTransformer() {
    StrategyListingTransformer.call(this);
    this.sourceType = ['rule-custom-strategy-listing', 'rule-custom-strategy-listing-alerts'];
  }
  RuleCustomStrategyListingTransformer.prototype = Object.create(StrategyListingTransformer.prototype);
  RuleCustomStrategyListingTransformer.constructor = RuleCustomStrategyListingTransformer;
  RuleCustomStrategyListingTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType.indexOf(sourceType) !== -1;
  };
  return RuleCustomStrategyListingTransformer;
};
RuleCustomStrategyListingTransformerFactory.$inject = ['StrategyListingTransformerFactory'];
module.exports = RuleCustomStrategyListingTransformerFactory;